import React, { memo } from 'react';
import PropTypes from 'prop-types';
import AccessRequestsTableRow from './AccessRequestsTableRow';
import style from '../../style/components/linkages/LinkedAccountsTable.module.scss';

const AccessRequestsTable = ({ linkageRequests }) => (
  <table className={style.table}>
    <thead>
      <tr>
        <th>ACCOUNT</th>
        <th>RELATIONSHIP</th>
        <th>WEBSITE NAME</th>
        <th>DATE / TIME</th>
        <th>ACTIONS</th>
        <th />
      </tr>
    </thead>
    {linkageRequests.length > 0 ? (
      <tbody>
        {linkageRequests.map((request) => (
          <AccessRequestsTableRow
            key={request.id}
            request={request}
            style={style}
          />
        ))}
      </tbody>
    ) : (
      <tfoot>
        <tr>
          <td className={style.none} colSpan="5">
            <p>Your account does not have any pending requests.</p>
          </td>
        </tr>
      </tfoot>
    )}
  </table>
);

AccessRequestsTable.propTypes = {
  linkageRequests: PropTypes.arrayOf(PropTypes.shape({})),
};

AccessRequestsTable.defaultProps = {
  linkageRequests: [],
};

export default memo(AccessRequestsTable);
